module.exports = __webpack_public_path__ + "img/imagem3.131d43ad.svg";